import { NavLink } from "react-router-dom"

export const ErrorLoadingMenu = () => {
    return (
      <li className="nav-item">
        <NavLink
          className="nav-link"
        >
          <p className="uppercase">Sin Menus Asignados
          </p>
        </NavLink>
      </li>
    )
  }